module.exports = __webpack_public_path__ + "assets/img/phone.bd06d753.svg";